"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRequestedOrientationDto = instanceOfRequestedOrientationDto;
exports.RequestedOrientationDtoFromJSON = RequestedOrientationDtoFromJSON;
exports.RequestedOrientationDtoFromJSONTyped = RequestedOrientationDtoFromJSONTyped;
exports.RequestedOrientationDtoToJSON = RequestedOrientationDtoToJSON;
exports.RequestedOrientationDtoToJSONTyped = RequestedOrientationDtoToJSONTyped;
const SpecialtyAbbrDto_1 = require("./SpecialtyAbbrDto");
const StipendDto_1 = require("./StipendDto");
const ShiftRequestStatus_1 = require("./ShiftRequestStatus");
const FacilityDto_1 = require("./FacilityDto");
const RequestedBy_1 = require("./RequestedBy");
const OrientationStatus_1 = require("./OrientationStatus");
const LicenseType_1 = require("./LicenseType");
const OrientationSessionDto_1 = require("./OrientationSessionDto");
/**
 * Check if a given object implements the RequestedOrientationDto interface.
 */
function instanceOfRequestedOrientationDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('licenseType' in value) || value['licenseType'] === undefined)
        return false;
    if (!('payRate' in value) || value['payRate'] === undefined)
        return false;
    if (!('totalRate' in value) || value['totalRate'] === undefined)
        return false;
    if (!('orientationSessions' in value) || value['orientationSessions'] === undefined)
        return false;
    if (!('totalSeats' in value) || value['totalSeats'] === undefined)
        return false;
    if (!('openSeats' in value) || value['openSeats'] === undefined)
        return false;
    if (!('facility' in value) || value['facility'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('specialtyCode' in value) || value['specialtyCode'] === undefined)
        return false;
    if (!('startTime' in value) || value['startTime'] === undefined)
        return false;
    if (!('lastEditedAt' in value) || value['lastEditedAt'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('requestStatus' in value) || value['requestStatus'] === undefined)
        return false;
    if (!('hasTimeLogged' in value) || value['hasTimeLogged'] === undefined)
        return false;
    if (!('hasTimeLoggedForSessions' in value) || value['hasTimeLoggedForSessions'] === undefined)
        return false;
    if (!('didNotWorkSessions' in value) || value['didNotWorkSessions'] === undefined)
        return false;
    if (!('requestedBy' in value) || value['requestedBy'] === undefined)
        return false;
    if (!('hasExpiredCredentialsInGracePeriod' in value) || value['hasExpiredCredentialsInGracePeriod'] === undefined)
        return false;
    return true;
}
function RequestedOrientationDtoFromJSON(json) {
    return RequestedOrientationDtoFromJSONTyped(json, false);
}
function RequestedOrientationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'licenseType': (0, LicenseType_1.LicenseTypeFromJSON)(json['licenseType']),
        'description': json['description'] == null ? undefined : json['description'],
        'payRate': json['payRate'],
        'totalRate': json['totalRate'],
        'orientationSessions': (json['orientationSessions'].map(OrientationSessionDto_1.OrientationSessionDtoFromJSON)),
        'totalSeats': json['totalSeats'],
        'openSeats': json['openSeats'],
        'facility': (0, FacilityDto_1.FacilityDtoFromJSON)(json['facility']),
        'status': (0, OrientationStatus_1.OrientationStatusFromJSON)(json['status']),
        'specialtyCode': json['specialtyCode'],
        'specialty': json['specialty'] == null ? undefined : (0, SpecialtyAbbrDto_1.SpecialtyAbbrDtoFromJSON)(json['specialty']),
        'startTime': (new Date(json['startTime'])),
        'lastEditedAt': (new Date(json['lastEditedAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'stipends': json['stipends'] == null ? undefined : (json['stipends'].map(StipendDto_1.StipendDtoFromJSON)),
        'stipendMinimumDistance': json['stipendMinimumDistance'] == null ? undefined : json['stipendMinimumDistance'],
        'isSearchable': json['isSearchable'] == null ? undefined : json['isSearchable'],
        'requestStatus': (0, ShiftRequestStatus_1.ShiftRequestStatusFromJSON)(json['requestStatus']),
        'hasTimeLogged': json['hasTimeLogged'],
        'hasTimeLoggedForSessions': json['hasTimeLoggedForSessions'],
        'didNotWorkSessions': json['didNotWorkSessions'],
        'requestedBy': (0, RequestedBy_1.RequestedByFromJSON)(json['requestedBy']),
        'isQualifiedForStipend': json['isQualifiedForStipend'] == null ? undefined : json['isQualifiedForStipend'],
        'hasExpiredCredentialsInGracePeriod': json['hasExpiredCredentialsInGracePeriod'],
    };
}
function RequestedOrientationDtoToJSON(json) {
    return RequestedOrientationDtoToJSONTyped(json, false);
}
function RequestedOrientationDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'licenseType': (0, LicenseType_1.LicenseTypeToJSON)(value['licenseType']),
        'description': value['description'],
        'payRate': value['payRate'],
        'totalRate': value['totalRate'],
        'orientationSessions': (value['orientationSessions'].map(OrientationSessionDto_1.OrientationSessionDtoToJSON)),
        'totalSeats': value['totalSeats'],
        'openSeats': value['openSeats'],
        'facility': (0, FacilityDto_1.FacilityDtoToJSON)(value['facility']),
        'status': (0, OrientationStatus_1.OrientationStatusToJSON)(value['status']),
        'specialtyCode': value['specialtyCode'],
        'specialty': (0, SpecialtyAbbrDto_1.SpecialtyAbbrDtoToJSON)(value['specialty']),
        'startTime': ((value['startTime']).toISOString()),
        'lastEditedAt': ((value['lastEditedAt']).toISOString()),
        'createdAt': ((value['createdAt']).toISOString()),
        'stipends': value['stipends'] == null ? undefined : (value['stipends'].map(StipendDto_1.StipendDtoToJSON)),
        'stipendMinimumDistance': value['stipendMinimumDistance'],
        'isSearchable': value['isSearchable'],
        'requestStatus': (0, ShiftRequestStatus_1.ShiftRequestStatusToJSON)(value['requestStatus']),
        'hasTimeLogged': value['hasTimeLogged'],
        'hasTimeLoggedForSessions': value['hasTimeLoggedForSessions'],
        'didNotWorkSessions': value['didNotWorkSessions'],
        'requestedBy': (0, RequestedBy_1.RequestedByToJSON)(value['requestedBy']),
        'isQualifiedForStipend': value['isQualifiedForStipend'],
        'hasExpiredCredentialsInGracePeriod': value['hasExpiredCredentialsInGracePeriod'],
    };
}
//# sourceMappingURL=RequestedOrientationDto.js.map